import React from "react";
import { Link2 } from "lucide-react";

import { HoverCard } from "./ResultsPrimitives.jsx";
import { getSegmentHoverCardAccentColor } from "../utils/fleetSegmentPresentation.js";
import { buildJoinedLoadJunctions, resolveJoinedLoadDropTarget } from "../utils/joinedLoadsTimeline.js";

// Chargements à la suite : pastille de lien entre les chargements et indication pendant le glisser.
export default function JoinedLoadsTimelineMarks({ items = [], dragState = null, disabled = false }) {
  const dropTarget = resolveJoinedLoadDropTarget(items, dragState);
  return (
    <>
      {buildJoinedLoadJunctions(items).map((junction) => (
        <HoverCard
          key={junction.key}
          title="Chargés à la suite"
          content={(
            <dl className="m-0 grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-0.5">
              {junction.rows.map(([label, value]) => (
                <React.Fragment key={label}>
                  <dt className="whitespace-nowrap font-semibold text-slate-500">{label}</dt>
                  <dd className="m-0 tabular-nums font-semibold text-slate-800">{value}</dd>
                </React.Fragment>
              ))}
            </dl>
          )}
          accentColor={getSegmentHoverCardAccentColor("loading")}
          disabled={disabled}
          delay={240}
          placement="bottom"
          referenceAsChild
        >
          <span
            role="img"
            aria-label="Chargés à la suite : livraisons après le dernier chargement"
            data-fleet-joined-loads-link="true"
            className="absolute -top-2 z-40 flex h-4.5 w-4.5 -translate-x-1/2 cursor-help items-center justify-center rounded-[4px] border border-white bg-accent text-white shadow-[0_1px_2px_rgba(0,0,0,0.3)]"
            style={{ left: `${junction.leftPercent}%` }}
          >
            <Link2 aria-hidden="true" className="h-3 w-3" strokeWidth={2.6} />
          </span>
        </HoverCard>
      ))}
      {dropTarget ? (
        <span
          data-fleet-joined-loads-drop-hint="true"
          className="pointer-events-none absolute top-full z-40 mt-1 whitespace-nowrap rounded-[4px] bg-accent px-1.5 py-0.5 text-[0.68rem] font-extrabold leading-tight text-white shadow-[0_1px_2px_rgba(0,0,0,0.25)]"
          style={{ left: `${dropTarget.leftPercent}%` }}
        >
          {`Charger avec ${dropTarget.label || "ce chargement"} · livrer après`}
        </span>
      ) : null}
    </>
  );
}
